import api from "./api";
import StorageService from "./StorageService";

const DailyFuelEntryService = {

  // CREATE
  create: async (data) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();

    const payload = {
      ...data,
      companyId: activeCompany.companyId,
      createdBy: login.employeeId,
      updatedBy: login.employeeId,
    };

    const response = await api.post("/dailyFuelEntry/save", payload);
    return response.data;
  },

  // // GET ALL
  // getAll: async () => {
  //   const response = await api.get(`/dailyFuelEntry/getAll`);
  //   return response.data.data || response.data;
  // },

getAll: async (pageNumber, noOfRows) => {
  const comp = StorageService.activeCompany();

  const response = await api.get(`/dailyFuelEntry/getAll`, {
    params: {
      companyId: comp.companyId,
      pageNumber,
      noOfRows,
    },
  });

  return response.data.data;
},

  // GET ACTIVE
  getActive: async () => {
    const response = await api.get(`/dailyFuelEntry/getActive`);
    return response.data.data || response.data;
  },

  // GET BY ID
  getById: async (id) => {
    const response = await api.get(`/dailyFuelEntry/getById/${id}`);
    return response.data;
  },

  // UPDATE
  update: async (id, data) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();

    const payload = {
      ...data,
      companyId: activeCompany.companyId,
      updatedBy: login.employeeId,
    };

    const response = await api.put(`/dailyFuelEntry/update/${id}`, payload);
    return response.data;
  },

  // DELETE
  remove: async (id) => {
    const response = await api.delete(`/dailyFuelEntry/${id}`);
    return response.data;
  },

  // UPDATE STATUS (toggle Active/Inactive)
  updateStatus: async (id) => {
    const response = await api.put(`/dailyFuelEntry/updatestatus/${id}`);
    return response.data;
  },

  getByProject: async (projectId) => {
    const res = await api.get(`/dailyFuelEntry/getByProject/${projectId}`);
    return res.data;
  },

  // DATE + PROJECT + VEHICLE LIVE FILTER SEARCH
  searchByDate: async ({
    companyId,
    employeeId,
    projectId,
    vehicleId,
    fromDate,
    toDate,
  }) => {
    const res = await api.get("/dailyFuelEntry/getSearch", {
      params: {
        companyId,
        employeeId,
        projectId: projectId || null,
        vehicleId: vehicleId || null,
        fromDate: fromDate || null,
        toDate: toDate || null,
      },
    });

    return res.data.data;
  },

  // EXPORT daily fuel entry (ALL)
  exportFuelEntry: async (companyId) => {
    const response = await api.get(`/dailyFuelEntry/export?companyId=${companyId}`);
    return response.data;
  },
  
  getNextVoucher: async (params) => {
    const res = await api.get("/dailyFuelEntry/getNextVoucher", {
      params
    });
    return res.data.voucher;
  },


};

export default DailyFuelEntryService;
